import {Component, EventEmitter, Output} from '@angular/core';
import {AbstractControl, FormBuilder} from '@angular/forms';

import {SubFormComponent} from '../_subform';
import {debounceTime, distinctUntilChanged, filter} from 'rxjs/operators';
import {DateService} from '@services/date.service';

@Component({
    providers: [
    ],
    selector: 'certificate-pb',
    templateUrl: './pb.component.html'
})
export class PbCertificateComponent extends SubFormComponent {

    @Output() remove = new EventEmitter<any>();

    public formGroupTemplate = this._fb.group({
        id: [''],
        number: [''],   // Номер удостоверения
        objects_string: [''],  // Объекты
        date_issue: [''],     // Дата выдачи
        date_end: [''],     // Дата окончания
        file: this._fb.group({    // Скан лицевой стороны
            file_id: [''],
            file_url: ['']
        }),
        file_back: this._fb.group({     // Скан обратной стороны
            file_id: [''],
            file_url: ['']
        })
    });

    constructor(
        private _fb: FormBuilder,
        private dateService: DateService,
    ) {
        super();
    }

    afterInit() {
        this.subs.push(
            /**
             * Если дата окончания не заполнена, то при изменении или заполнении даты выдачи
             * дата окончания будет автоматически подставлена
             */
            this.form.get('date_issue').valueChanges.pipe(
                debounceTime(30),
                distinctUntilChanged(),
                filter((value) => this.dateService.for(value).isValid()),
                filter(() => Boolean(!this.form.get('date_end').value))
            ).subscribe((date) => {
                this.form.get('date_end').patchValue(this.dateService.for(date).addMonth(36).dateString);
            })
        );
    }


    /*
    * Устанавливаем значение объектов из модалки.
    * Геренируем строку с перечислением объектов: 2, 3, 5.1, 6
    * */
    setObjectsToMethod(objectsControl: AbstractControl, objects: any[]) {
        const objectsString = objects.reduce((value, item) => {
            return value += `${item.number}, `;
        }, '').slice(0, -2);
        objectsControl.markAsDirty();
        objectsControl.patchValue(objectsString);
    }

    /*
    * Очищаем значения объектов для метода
    * */
    clearObjectsForMethod(objectsControl: AbstractControl) {
        objectsControl.patchValue('');
    }

    onRemoveClick() {
        this.remove.emit();
    }
}
